import { render, staticRenderFns } from "./TechnicianIndex.vue?vue&type=template&id=646ee0c7&"
import script from "./TechnicianIndex.vue?vue&type=script&lang=js&"
export * from "./TechnicianIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports